export const RemoveObjectKeys = <T>(obj: Record<any, T>, keys: string[]): Record<any, T> => {
	const output: Record<any, T> = {}

	Object.keys(obj).forEach((key) => {
		if (!keys.includes(key))
		{
			output[key] = obj[key]
		}
	})

	return output
}